import { UserIcon } from "@heroicons/react/outline";
import Moment from "react-moment";

const MessageCard = ({
  id,
  message,
  timestamp,
  userId,
  userImage,
  userName,
}) => {
  return (
    <div className="bg-gray-100 py-2 px-2 rounded-md border border-gray-300 shadow flex flex-col space-y-3">
      <div className="flex items-center space-x-3">
        {userImage ? (
          <img src={userImage} alt="" className="h-10 rounded-full shadow" />
        ) : (
          <UserIcon className="h-10 px-2 py-2 rounded-full bg-gray-100 border border-gray-300 shadow" />
        )}
        <h1 className="font-medium">{userName}</h1>
      </div>
      <div>
        <p className="ml-2">{message}</p>
      </div>
      <div className="flex justify-end">
        <Moment className="text-xs" fromNow>
          {timestamp?.toDate()}
        </Moment>
      </div>
    </div>
  );
};

export default MessageCard;
